import React, { useState } from 'react';
import { useTranslation } from '../../../locale/useTranslation';
import BossDialog from '../../../components/BossDialog';
import { utility } from '../../../framework/utility/utilityProvider';
import { SchedulingHelper } from '../helper/SchedulingHelper';
import { ENTITYNAME } from '../../../framework/constant/constant';
import { ProgressBar } from '@progress/kendo-react-progressbars';
import ActionButton from '../../../framework/forms/helpercomponents/buttons/ActionButton';
import CancelButton from '../../../framework/forms/helpercomponents/buttons/CancelButton';
import { toast } from 'react-toastify';
import { TimePickerWithFormat } from '../../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';

const CreateLoopForm = (props) => {

    const { onClose, selectedItem = {}, addScheduleItems, getSelectedChannel, copyPasteDataItem = [], schedulerData = [], saveCompleteScheduleChildrenandRefresh } = props;
    const lang = useTranslation();

    const totalDuration = copyPasteDataItem?.reduce((total, item) => total + item.Duration, 0) || 0;

    const [dataItem, setDataItem] = useState({
        StartTime: selectedItem.EndSlotDateTime ? utility.convertMilisecondsToStringWithFrames(selectedItem.EndSlotDateTime) : "",
        EndTime: selectedItem.EndSlotDateTime ? utility.convertMilisecondsToStringWithFrames(selectedItem.EndSlotDateTime + totalDuration) : "",
        Duration: totalDuration ? utility.convertMilisecondsToStringWithFrames(totalDuration) : ""
    });

    const [showProgressBar, setShowProgressBar] = useState({ okButton: false, progressBarPopup: false });
    const [progressData, setProgressData] = useState({ message: '', progress: 0 });

    const onChange = (e) => {
        const { name, value } = e.target;
        const updated = { ...dataItem, [name]: value };

        const startTimeMS = utility.convertStringWithFramesToMilliseconds(updated.StartTime);

        if (name === "EndTime") {
            const endTimeMS = utility.convertStringWithFramesToMilliseconds(value);
            const durationMS = endTimeMS - startTimeMS;
            updated.Duration = utility.convertMilisecondsToStringWithFrames(durationMS);
        }

        if (name === "Duration") {
            const durationMS = utility.convertStringWithFramesToMilliseconds(value);
            const endTimeMS = startTimeMS + durationMS;
            updated.EndTime = utility.convertMilisecondsToStringWithFrames(endTimeMS);
        }

        setDataItem(updated);
    };

    const handleExecute = () => {
        const startMS = utility.convertStringWithFramesToMilliseconds(dataItem.StartTime);
        const endMS = utility.convertStringWithFramesToMilliseconds(dataItem.EndTime);

        if (startMS > endMS) {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '13px' }}>{lang.start_time_cannot_be_greater_than_end_time_error_message}</div>
                </div>,
                { position: toast.POSITION.TOP_RIGHT }
            );
            return;
        }

        setProgressData({ message: 'Looping Items...', progress: 1 });
        setShowProgressBar({ okButton: false, progressBarPopup: true });

        setTimeout(async () => {
            try {
                const startDateTime = selectedItem.EndSlotDateTime;
                const date = utility.convertMilisecondsToDateString(startDateTime);
                const endDateTime = utility.convertStringDatetoMilliseconds(date) + endMS;
                let tempStartDateTime = startDateTime;

                while (tempStartDateTime < endDateTime) {
                    const progressPercent = Math.round(((tempStartDateTime - startDateTime) / (endDateTime - startDateTime)) * 100);
                    setProgressData({ message: 'Looping Items...', progress: progressPercent - 1 });

                    const dataToSave = SchedulingHelper.prepareData(
                        ENTITYNAME.ProgramSchedule,
                        getSelectedChannel(),
                        copyPasteDataItem,
                        selectedItem,
                        schedulerData,
                        true
                    );

                    await addScheduleItems(selectedItem, dataToSave, false);
                    tempStartDateTime += totalDuration;
                }

                await saveCompleteScheduleChildrenandRefresh();

                setProgressData({ message: 'Process Completed !!', progress: 100 });
                setShowProgressBar({ progressBarPopup: true, okButton: true });
            } catch (err) {
                console.error(err);
                toast.error("Looping failed.");
                setShowProgressBar({ progressBarPopup: false, okButton: false });
            }
        }, 1000);
    };

    return (
        <BossDialog title={lang.create_loop_dialog_header} width="300px" onClose={onClose}>
            <div className="flex gap-2 mb-3">
                <ActionButton onClick={handleExecute} name={lang.execute_button_text} disabled={showProgressBar.progressBarPopup} />
                <CancelButton onClick={onClose} title={lang.cancel_button_text} />
            </div>

            <div className="mt-2">
                <label>{lang.start_time_label} *</label>
                <TimePickerWithFormat name="StartTime" value={dataItem.StartTime} onChange={onChange} disabled />
            </div>
            <div className="mt-2">
                <label>{lang.end_time_label} *</label>
                <TimePickerWithFormat name="EndTime" value={dataItem.EndTime} onChange={onChange} />
            </div>
            <div className="mt-2">
                <label>{lang.duration_label} *</label>
                <TimePickerWithFormat name="Duration" value={dataItem.Duration} onChange={onChange} />
            </div>

            {showProgressBar.progressBarPopup && (
                <div id="myProgressBar" className="mt-4">
                    <div className="myProgressBarBox">
                        <ProgressBar
                            label={({ value }) => <strong>{value}%</strong>}
                            labelPlacement="center"
                            progressStyle={{ backgroundColor: 'green' }}
                            value={progressData.progress}
                            style={{ width: '360px' }}
                        />
                        <div className="message mt-2">
                            <p>{progressData.message}</p>
                        </div>
                        {showProgressBar.okButton && (
                            <button
                                onClick={() => {
                                    setShowProgressBar({ ...showProgressBar, progressBarPopup: false });
                                    onClose();
                                }}
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bg-success text-white mt-2"
                                style={{ width: '50px' }}
                            >
                                Ok
                            </button>
                        )}
                    </div>
                </div>
            )}
        </BossDialog>
    );
};

export default CreateLoopForm;
